import React, { useEffect, useState } from "react";
import { ChartOptions } from "chart.js";
import { useQuery } from "react-query";
import { SMSConversionReportApi } from "../../Api";
import { AxiosResponse } from "axios";
import { Pie } from "react-chartjs-2";
import ReportCampaignList from "./CampaignList";

export default function SMSConversionReport() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [Data, setData] = useState({
    Total_Message: 0,
    Delivered: 0,
    Undelivered: 0,
    Received: 0,
  });

  const Report = useQuery({
    queryKey: ["SMS-Conversion-Report"],
    queryFn: SMSConversionReportApi,
    onSuccess: (resp: AxiosResponse) => {
      const rawData = resp.data?.data;
      // Convert string values to numbers
      setData({
        Total_Message: parseInt(rawData.Total_Message, 10) || 0,
        Delivered: parseInt(rawData.Delivered, 10) || 0,
        Undelivered: parseInt(rawData.Undelivered, 10) || 0,
        Received: parseInt(rawData.Received, 10) || 0,
      });
    },
    enabled: false,
  });

  useEffect(() => {
    Report.refetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Pie chart configuration
  const options: ChartOptions<"pie"> = {
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const dataset = tooltipItem.dataset;
            const dataIndex = tooltipItem.dataIndex;
            const total = dataset.data.reduce(
              (sum: number, value: number) => sum + value,
              0
            );
            const currentValue = dataset.data[dataIndex];
            const percentage = ((currentValue / total) * 100).toFixed(2);
            const label = tooltipItem.chart.data.labels[dataIndex];

            return [`${label}: ${percentage}%`, `Value ${currentValue}`];
          },
        },
      },
      legend: {
        position: "top", // Adjust legend position based on screen width
        labels: {
          font: {
            size: 14,
          },
          generateLabels: (chart: any) => {
            const data = chart.data;
            if (!data.labels || !data.datasets.length) return [];

            const total = data.datasets[0].data
              .filter(
                (value: any): value is number => typeof value === "number"
              )
              .reduce((sum: any, value: number) => sum + value, 0);

            return data.labels
              .map((label: any, index: number) => {
                const value = data.datasets[0].data[index] as
                  | number
                  | undefined;
                if (value === undefined) return null;

                const percentage = ((value / total) * 100).toFixed(2);

                const backgroundColor = Array.isArray(
                  data.datasets[0].backgroundColor
                )
                  ? data.datasets[0].backgroundColor[index]
                  : undefined;

                const borderColor = Array.isArray(data.datasets[0].borderColor)
                  ? data.datasets[0].borderColor[index]
                  : undefined;

                return {
                  text: `${label}: ${percentage}%  value:${value}`,
                  fillStyle: backgroundColor,
                  strokeStyle: borderColor,
                  hidden: !chart.getDataVisibility(index),
                  index,
                };
              })
              .filter(Boolean);
          },
        },
      },
    },
    responsive: true,
  };

  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <div className="card mt-4">
            <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
              <h5 className="m-0 flex-grow-1">SMS Conversion Report</h5>
            </div>
            <div className="card-body">
              {Data &&
              Data.Total_Message > 0 &&
              Data.Delivered >= 0 &&
              Data.Undelivered >= 0 &&
              Data.Received >= 0 ? (
                <div className="responsive-charts">
                  <Pie
                    data={{
                      labels: [
                        "Total Message",
                        "Delivered",
                        "Undelivered",
                        "Received",
                      ],
                      datasets: [
                        {
                          label: "SMS Conversion",
                          data: [
                            Data.Total_Message,
                            Data.Delivered,
                            Data.Undelivered,
                            Data.Received,
                          ],
                          backgroundColor: [
                            "#4682B4",
                            "#98FB98",
                            "#F08080",
                            "#FFFACD",
                          ],
                        },
                      ],
                    }}
                    options={options}
                  />
                </div>
              ) : (
                <p className="fw-semibold fs-5 text-center mb-0">
                  No data found
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
      <ReportCampaignList
        RedirectURL="/report/sms-conversion-report/chats"
        ReportTitle="Campaign List"
      />
    </>
  );
}
